import {PaginatedResult} from "../../models/requests/paginated-result/paginated.result";
import {apiService} from "../api.service";
import {PaginatedRequest} from "../../models/requests/paginated-request/paginated.request";
import {StatementFile} from "../../models/accounting/statements";

export class StatementsFilesService {
    public async getList(request: PaginatedRequest): Promise<PaginatedResult<StatementFile>> {
        return (await apiService.get<PaginatedResult<StatementFile>>(
            "accounting/statements-files",
            {
                params: request.toParams()
            }
        )).data;
    }
}

export const statementsFilesService = new StatementsFilesService();

